<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2023-02-21 16:06:53
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2023-02-22 16:03:54
 * @FilePath: \pigbox\src\views\Login\Login.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="loginpage">
    <vue-particles color="#409EFF" :particleOpacity="1"></vue-particles>
    <div class="loginbox">
      <div style="width:100%;height:50px;text-align:center;color:white;font-size:25px">管理员登录</div>
      <!-- <div class="login-itemBox"></div>
      <div class="login-itemBox"></div>-->
      <el-form label-position="top" label-width="80px" :model="form">
        <!-- > -->
        <el-form-item>
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.password" type="password"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" style="width:100%" @click="submit">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: "",
        password: ""
      }
    };
  },
  methods: {
    submit() {
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: "/ExamineService/loginExamineUser", // 接口地址
        data: {
          loginName: this.form.name,
          password: this.form.password
        }
      }).then(res => {
        console.log(res);
        if (res.id != null) {
          this.$store.commit("setUserId", res);
          this.$router.push("/shop");
        }
      });
    }
  }
};
</script>

<style>
.loginpage {
  width: 100vw;
  height: 100vh;
  background-color: #5da6a3;
}
.loginbox {
  position: absolute;
  margin: auto;
  width: 400px;
  height: 300px;
  top: 50vh;
  left: 50vw;
  transform: translate(-200px, -150px);
  background: #5da6a49c;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  /* background-color: aqua; */
  padding: 10px;
}
.login-itemBox {
  width: 100%;
  height: 50px;
  background-color: aquamarine;
  margin-top: 20px;
}
</style>    